const languages =
    {
        es: {
            userName:'Usuario',
            password:'Contraseña',
            loginBtn:'Ingresar',
            loading:'Cargando',
            loggedIn: 'Bienvenido',
            logoutBtn: 'Cerrar Sesión',
            forgot: '¿Olvidó su clave?',
            loginMsg: 'Digite su usuario y contraseña para acceder',
            logout: 'Cerrar Sesión',
            generateP12: 'Generar Certificado',
            caCertificate: 'Descargar Certificado de la CA',
            serverError: 'Error conectando al servidor',
            referenceNumber: 'Número de referencia',
            authCode: 'Código de autorización',
            generateCertP12: 'Generar P12',
            goBack: 'Regresar',
            generateP12msg: 'Digite los códigos recibidos y seleccione una contraseña para obtener su P12',
            confirmPassword: 'Confirmar Contraseña',
            dontMatch: 'Password y confirmación no coinciden',
            processOk: 'Proceso realizado exitosamente',
            forgotPasswordmsg: 'Digite su correo y recibirá un link para cambiar su contraseña',
            mail : 'Correo electrónico',
            required: 'Campo requerido',
            invalidMail: 'Correo Inválido',
            forgotBtn: 'Solicitar cambio de clave',
            mailSent: 'Se ha enviado un correo para el cambio de clave a: ',
            changePassmsg:'Por seguridad digite su clave actual y escoja una nueva',
            currentPass: 'Clave actual',
            newPass: 'Nueva clave',
            confirmNewPass: 'Confirmar nueva clave',
            changePass: 'Cambiar clave',
            rights: 'Version 2.0 - 2019 Derechos Reservados - Desarrollado por Netco LTDA',
            serialNumber: 'Serial',
            certificatesTitle: 'Lista de Certificados',
            certificatesHTitle: 'Lista de Certificados Archivados',
            certificatesInfo: 'Estos son los certificados generados en Netco PKI',
            cn: 'Nombre (CN)',
            cedula: 'ID/Cedula',
            statusLabel: 'Estado',
            type: 'Tipo',
            actions: 'Acciones',
            detailsLabel: 'Detalles',
            renewLabel: 'Renovar',
            revokeLabel: 'Revocar',
            deleteLabel: 'Borrar',
            regenLabel: 'Regenerar',
            approveLabel: 'Aprobar',
            rejectLabel: 'Rechazar',
            confirmTitle: 'Confirmar acción',
            detailsTitle: 'Detalles del certificado {0}',
            confirmApprove: '¿Está seguro de aprobar la solicitud del certificado con serial {0}?',
            confirmReject: '¿Está seguro de rechazar la solicitud del certificado con serial {0}?',
            confirmDelete: '¿Está seguro de borrar la solicitud del certificado con serial {0}?',
            confirmDeleteUser: '¿Está seguro de borrar el usuario {0}?',
            confirmRegen: '¿Está seguro de regenerar la solicitud del certificado con serial {0}?',
            confirmRenew: 'Para renovar el certificado se debe revocar el anterior, si está seguro seleccione el motivo de revocación',
            confirmRevoke: 'Seleccione el motivo de revocación para el certificado con serial {0}',
            confirmMove: '¿Está seguro de archivar los certificados revocados?, esta acción no se puede deshacer',
            btnOK: 'Aceptar',
            btnCancel: 'Cancelar',
            email:'Correo Electrónico',
            telefono:'Teléfono',
            dateLabel: 'Fecha de modificación',
            notAfterLabel: 'Fecha de Vencimiento',
            issuedDateLabel:'Fecha de emisión',
            country: 'País',
            direccion: 'Dirección',
            city: 'Ciudad',
            state: 'Estado/Departamento',
            organization: 'Empresa',
            organizationalUnit: 'Area de la empresa',
            authCodeLabel: 'Código de autorización',
            referenceNumberLabel: 'Número de referencia',
            equalLabel:'Igual a',
            containsLabel:'Contiene',
            listCertsLabel:'Listar certificados',
            listCertshLabel:'Listar certificados históricos',
            issueCRL: 'Actualizar CRL',
            moveCerts: 'Archivar certificados',
            newCertRequest: 'Nuevo certificado',
            requestTypeLabel:'Solicitar certificado para',
            areaCode:'Código de area',
            newRequestInfo:'Digite la información solicitada para generar una nueva solicitud de certificado',
            generateRequest: 'Generar Solicitud',
            generatePKCS10Request: 'Certificado con CSR',
            pkcs10Info:'Copie y pegue el CSR en la siguiente casilla y oprima el botón validar para continuar',
            pkcs10Generate: 'Generar y descargar certificado',
            pkcs10PlaceHolder:'Una vez haya pegado el CSR aquí el sistema diligenciará el asunto y podrá continuar',
            csrLabel:'CSR',
            pkcs10Subject:'Asunto',
            changePassLabel:'Cambiar clave',
            adminLabel: 'Parametrización',
            name_column: 'Nombre',
            value_column: 'Valor',
            action_column: 'Acciones',
            searchLabel: 'Buscar',
            editLabel: 'Editar',
            system_info: 'Mostrar información del sistema',
            admin_title: 'Opciones de administrador',
            tables_tab: 'Tablas',
            config_tab: 'Configuración',
            system_security_provider: 'Proveedor de seguridad:',
            system_state: 'Estado:',
            create_ip_modal: 'Crear servidor IP',
            create_user_modal: 'Crear usuario',
            ip_option: 'IPs autorizadas',
            user_option: 'Usuarios',
            user_starts: 'Usuario comienza por...',
            createLabel: 'Crear',
            clearLabel: 'Limpiar',
            orderLabel: 'Ordenar',
            results_per_page: 'Resultados por pagina: ',
            total_elements: 'Total de $0 elementos',
            ip_column: 'IP',
            user_column: 'Usuario',
            status_column: 'Estado',
            role_column: 'Perfil',
            system_hsm: 'Versión HSM :',
            system_licence_used: 'Licencias usadas (certificados pendientes o emitidos):',
            system_licence: 'Total de Licencias (certificados):',
            unlimitedLabel: 'Ilimitados',
            activeLabel: 'Activo',
            changeLabel: 'Cambiar clave',
            select_cert: 'Seleccionar certificado',
            last_login_column: 'Ultimo login',
            filter: 'Filtrar',
            export: 'Exportar',
            reportsLabel: 'Logs',
            date_column: 'Fecha',
            operation_column: 'Operacion',
            detail_column: 'Detalle',
            showHistoryLabel: '¿Listar certificados archivados?',
            publicreqLabel: 'Solicitar certificado',
            publicpkcs10Label:'Solicitar certificado con CSR',
            p12PasswordModalMessage: 'Seleccione una clave para el p12',
            reportsButton: 'Descargar reporte general de certificados',
            reportsONACLabel: 'Seleccione el rango de fechas para obtener el reporte',
            testSMTP: 'Probar servidor SMTP',
            viewLogs: 'Logs del sistema',
            netcoTS: 'Usar con Netco TS'
        },
        en: {
            userName:'Username',
            password:'Password',
            loginBtn:'Login',
            loading:'Loading',
            loggedIn: 'Welcome',
            logoutBtn: 'Logout',
            forgot: '¿Forgot your password?',
            loginMsg: 'Type your username and password to login',
            logout: 'Logout',
            generateP12: 'Generate certificate',
            caCertificate: 'Download CA certificate',
            serverError : 'Error contacting server',
            referenceNumber: 'Reference Number',
            authCode: 'Autorization Code',
            generateCertP12: 'Generate P12',
            goBack: 'Go Back',
            generateP12msg: 'Type your codes and create a password to generate your p12 file',
            confirmPassword: 'Confirm password',
            dontMatch: 'Password and confirmation don"t match',
            processOk: 'Process executed succesfully',
            forgotPasswordmsg: 'Type your email to get a link and change your password',
            mail : 'Mail',
            required: 'Mandatory Field',
            invalidMail: 'Invalid mail',
            forgotBtn: 'Request password change',
            mailSent: 'A mail has sent to change your password to: ',
            changePassmsg:'For security reasons type yout current password and pick a new one',
            currentPass: 'Current Password',
            newPass: 'New Password',
            confirmNewPass: 'Confirm new Password',
            changePass: 'Change password',
            rights: 'Version 2.0 - 2019 All Rights Reserved - Powered By Netco LTDA',
            serialNumber: 'Serial',
            certificatesTitle: 'Certificates list',
            certificatesHTitle: 'Archived certificates list',
            certificatesInfo: 'These are the certificates created on Netco PKI',
            cn: 'Common Name (CN)',
            cedula: 'ID/Cedula',
            statusLabel: 'Status',
            type: 'Type',
            actions: 'Actions',
            detailsLabel: 'Details',
            renewLabel: 'Renew',
            revokeLabel: 'Revoke',
            deleteLabel: 'Delete',
            regenLabel: 'Regenerate',
            approveLabel: 'Approve',
            rejectLabel: 'Reject',
            confirmTitle: 'Confirm action',
            detailsTitle: 'Certificate"s {0} details',
            confirmApprove: '¿Are you sure to approve certificate request with serial {0}?',
            confirmReject: '¿Are you sure to reject certificate request with serial {0}?',
            confirmDelete: '¿Are you sure to delete request with serial {0}?',
            confirmDeleteUser: '¿Are you sure to delete user {0}?',
            confirmRegen: '¿Are you sure to regenerate request with serial {0}?',
            confirmRenew: 'To renew a cert you need to revoke the current one first, if you are sure select the revocation reason',
            confirmRevoke: 'Select the revocation reason for certifiate serial {0}',
            confirmMove: '¿Are you sure to archive revoked certs? You cannot undo this action',
            btnOK: 'OK',
            btnCancel: 'Cancel',
            email:'Email',
            telefono:'Phone',
            dateLabel: 'Modification Date',
            notAfterLabel: 'Expiration Date',
            issuedDateLabel:'Issued Date',
            country: 'Country',
            direccion: 'Address',
            city: 'City',
            state: 'State',
            organization: 'Company',
            organizationalUnit: 'Company Area',
            authCodeLabel: 'Authorization Code',
            referenceNumberLabel: 'Reference Number',
            equalLabel:'Equals to',
            containsLabel:'Contains',
            listCertsLabel:'List certificates',
            listCertshLabel:'List historic certificates',
            issueCRL: 'Issue CRL',
            moveCerts: 'Move certificates to history',
            newCertRequest: 'New certificate',
            requestTypeLabel:'Request certificate to',
            areaCode:'Area Code',
            newRequestInfo:'Enter the information to generate a new certificate request',
            generateRequest: 'Generate request',
            generatePKCS10Request: 'CSR request',
            pkcs10Info:'Copy and paste the CSR on the following textarea and press validate to continue',
            pkcs10Generate: 'Generate and download certificate',
            pkcs10PlaceHolder:'Paste your CSR here',
            csrLabel:'CSR',
            pkcs10Subject:'Subject',
            changePassLabel:'Change password',
            adminLabel: 'Setup',
            name_column: 'Name',
            value_column: 'Value',
            action_column: 'Actions',
            searchLabel: 'Search',
            editLabel: 'Edit',
            system_info: 'Show system information',
            admin_title: 'Administrator Options',
            tables_tab: 'Tables',
            config_tab: 'Configuration',
            system_security_provider: 'Security Provider:',
            system_state: 'Status:',
            create_ip_modal: 'Create Server IP',
            create_user_modal: 'Create user',
            ip_option: 'Authorized IPs',
            user_option: 'Users',
            user_starts: 'User starts with...',
            createLabel: 'Create',
            clearLabel: 'Clear',
            orderLabel: 'Order',
            results_per_page: 'Results per page: ',
            total_elements: 'Total of $0 elements',
            ip_column: 'IP',
            user_column: 'User',
            status_column: 'Status',
            role_column: 'Profile',
            system_hsm: 'HSM library version:',
            system_licence_used: 'Used Licenses:',
            system_licence: 'Total licenses:',
            unlimitedLabel: 'Unlimited',
            activeLabel: 'Active',
            changeLabel: 'Change password',
            select_cert: 'Select certificate',
            last_login_column: 'Last Login',
            filter: 'Filter',
            export: 'Export',
            reportsLabel: 'Logs',
            date_column: 'Date',
            operation_column: 'Operation',
            detail_column: 'Detail',
            showHistoryLabel: '¿List archived certificates?',
            publicreqLabel: 'Solicitar certificado',
            publicpkcs10Label:'Solicitar certificado con CSR',
            p12PasswordModalMessage: 'Select a password for the p12 to generate',
            reportsButton: 'Download certificates general Report',
            reportsONACLabel: 'Select a range date to get the report',
            testSMTP: 'Test SMTP Server',
            viewLogs: 'System logs',
            netcoTS: 'Use it with Netco TS'
        }
    };
export default languages;
